<nav class="hz-bar">
  <span class="hz-logo-item" aria-hidden="true">
    <img class="hz-logo" src="assets/icons/eInvoiceViewer.svg" alt="">
  </span>

  <h2 class="hz-nav-link hz-active hz-title" i18n="@@einvoice.header.title">e-invoice viewer</h2>

  <a class="hz-nav-link" [href]="getLink('support')" target="_blank" rel="noopener" i18n="@@einvoice.menuitem.support">
    Support
  </a>

  @if (((installable$ | async) && !isStandalone) || showIosInstall) {
    <button type="button" class="hz-nav-link" (click)="installApp()"
      i18n="@@einvoice.header.add-to-apps"
      i18n-title="@@einvoice.header.add-to-apps.tooltip"
      title="Open e-invoices straight from your desktop – no upload needed.">
      + Add to your apps
    </button>
  }

  <div class="version">
    {{ version }}
  </div>

  <app-lang-segment class="hz-lang"
    role="group"
    [attr.aria-label]="getTranslation('language-select')"
    [locale]="activeLocale"
    [locales]="localePair"
    [labels]="localeLabels"
    (localeChange)="localeSelected($event)"></app-lang-segment>
</nav>
